import {
  Button,
  Card,
  Carousel,
  Checkbox,
  Col,
  Divider,
  Dropdown,
  Menu,
  MenuProps,
  Row,
  Table,
  Tooltip,
} from "antd";
import React, { useEffect, useRef, useState } from "react";
import "../../Common/Dashboardlayout.css";
import { useTheme } from "../../Context/ThemeContext";
import { StarTwoTone } from "@ant-design/icons";
import { BsThreeDots } from "react-icons/bs";
const dataSource = [
  {
    key: "1",
    name: "Mike",
    age: 32,
    address: "100",
  },
  {
    key: "2",
    name: "John",
    age: 42,
    address: "200",
  },
  {
    key: "3",
    name: "Tony",
    age: 42,
    address: "300",
  },
  {
    key: "4",
    name: "Lisa",
    age: 42,
    address: "400",
  },
  {
    key: "5",
    name: "Jiny",
    age: 42,
    address: "500",
  },
];

const columns = [
  {
    title: "CustomerName",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "Qty",
    dataIndex: "age",
    key: "age",
  },
  {
    title: "Amt",
    dataIndex: "address",
    key: "address",
  },
];
const columns1 = [
  {
    title: "SuppliersName",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "Qty",
    dataIndex: "age",
    key: "age",
  },
  {
    title: "Amt",
    dataIndex: "address",
    key: "address",
  },
];
const columns2 = [
  {
    title: "ProductName",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "Qty",
    dataIndex: "age",
    key: "age",
  },
  {
    title: "Amt",
    dataIndex: "address",
    key: "address",
  },
];

const TopSegment: React.FC = () => {
  const themeData: any = useTheme();
  const contentStyle: React.CSSProperties = {
    color: themeData?.themeData?.themeColor,
    backgroundColor: `${themeData?.themeData?.themeColor}20`,
    padding: "5px",
    margin: 0,
    borderTopLeftRadius: "5px",
    borderTopRightRadius: "5px",
  };
  const ref = useRef<HTMLDivElement>(null);
  const onWheel = (e: any) => {
    const elelemnt = ref.current;
    if (elelemnt) {
      if (e.deltaY == 0) return;
      elelemnt.scrollTo({
        left: elelemnt.scrollLeft + e.deltaY,
      });
    }
  };

  const [selectChecked, setSelectChecked] = useState<any>([
    "Customers",
    "Suppliers",
    "Products",
    "Orders",
    "Expenses",
  ]);
  const handleTop5Selection = (val: any) => {
    if (val?.target?.checked) {
      setSelectChecked((prev: any) => [...prev, val?.target?.value]);
    } else {
      setSelectChecked((prev: any) =>
        prev.filter((v: any) => v !== val?.target?.value)
      );
    }
  };

  const items: MenuProps["items"] = [
    {
      key: "1",
      label: (
        <Col span={8}>
          <Checkbox
            checked={selectChecked.find((chk: any) => chk === "Customers")}
            value="Customers"
            onChange={handleTop5Selection}
          >
            Customers
          </Checkbox>
        </Col>
      ),
    },
    {
      key: "2",
      label: (
        <Col span={8}>
          <Checkbox
            checked={selectChecked.find((chk: any) => chk === "Suppliers")}
            value="Suppliers"
            onChange={handleTop5Selection}
          >
            Suppliers
          </Checkbox>
        </Col>
      ),
    },
    {
      key: "3",
      label: (
        <Col span={8}>
          <Checkbox
            checked={selectChecked.find((chk: any) => chk === "Products")}
            value="Products"
            onChange={handleTop5Selection}
          >
            Products
          </Checkbox>
        </Col>
      ),
    },
    {
      key: "4",
      label: (
        <Col span={8}>
          <Checkbox
            checked={selectChecked.find((chk: any) => chk === "Orders")}
            value="Orders"
            onChange={handleTop5Selection}
          >
            Orders
          </Checkbox>
        </Col>
      ),
    },
    {
      key: "5",
      label: (
        <Col span={8}>
          <Checkbox
            checked={selectChecked.find((chk: any) => chk === "Expenses")}
            value="Expenses"
            onChange={handleTop5Selection}
          >
            Expenses
          </Checkbox>
        </Col>
      ),
    },
  ];
  return (
    <>
      <Row gutter={6}>
        <Col
          span={1}
          style={{
            borderRadius: 10,
            backgroundColor: `${themeData?.themeData?.themeColor}20`,
            textAlign: "center",
            padding: 4,
          }}
        >
          <div
            style={{
              padding: "2px",
              // width: "35px",
              height: "100%",
            }}
          >
            <Dropdown
              menu={{ items }}
              placement="bottomLeft"
              arrow={{ pointAtCenter: true }}
            >
              <Tooltip title="Select the segments wants to show">
                <Button>
                  <BsThreeDots />
                </Button>
              </Tooltip>
            </Dropdown>
            <div
              style={{
                width: "100%",
                height: "calc(100% - 30px)",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "100%",
                  // margin: "auto 0px",
                }}
              >
                <p
                  style={{
                    fontSize: "1.5rem",
                    fontWeight: "bold",
                    color: themeData?.themeData?.themeColor,
                    whiteSpace: "nowrap",
                    textTransform: "uppercase",
                    transform: "rotate(-90deg)",
                  }}
                >
                  Top 5
                </p>
              </div>
            </div>
          </div>
        </Col>
        <Col span={23}>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              overflowX: "scroll",
              overflowY: "hidden",
              flexWrap: "nowrap",
              alignItems: "stretch",
              // backgroundColor: themeData?.themeData?.themeColor,
            }}
            onWheel={onWheel}
            ref={ref}
          >
            {selectChecked.find((chk: any) => chk === "Customers") && (
              <Card className="card-pt" style={{ flexShrink: 0, width: "30%" }}>
                <Divider style={contentStyle}>
                  {/* <StarTwoTone />  */}
                  Customers
                </Divider>
                <Table
                  className="table-pt"
                  style={{ padding: 10 }}
                  dataSource={dataSource}
                  columns={columns}
                  pagination={false}
                  rowClassName="top5TableRows"
                />
              </Card>
            )}
            {selectChecked.find((chk: any) => chk === "Suppliers") && (
              <Card className="card-pt" style={{ flexShrink: 0, width: "30%" }}>
                <Divider style={contentStyle}>Suppliers</Divider>
                <Table
                  className="table-pt"
                  dataSource={dataSource}
                  columns={columns1}
                  pagination={false}
                  style={{ padding: 10 }}
                />
              </Card>
            )}
            {selectChecked.find((chk: any) => chk === "Products") && (
              <Card className="card-pt" style={{ width: "30%", flexShrink: 0 }}>
                <Divider style={contentStyle}>Products</Divider>
                <Table
                  className="table-pt"
                  dataSource={dataSource}
                  columns={columns2}
                  pagination={false}
                  style={{
                    padding: 10,
                  }}
                />
              </Card>
            )}
            {/* <Dropdown.Button menu={{ items, onClick: onMenuClick }} /> */}
            {selectChecked.find((chk: any) => chk === "Orders") && (
              <Card className="card-pt" style={{ width: "30%", flexShrink: 0 }}>
                <Divider style={contentStyle}>Orders</Divider>
                <Table
                  className="table-pt"
                  dataSource={dataSource}
                  columns={columns}
                  pagination={false}
                  style={{
                    padding: 10,
                  }}
                />
              </Card>
            )}
            {selectChecked.find((chk: any) => chk === "Expenses") && (
              <Card className="card-pt" style={{ width: "30%", flexShrink: 0 }}>
                <Divider style={contentStyle}>Expenses</Divider>
                <Table
                  className="table-pt"
                  dataSource={dataSource}
                  columns={columns}
                  pagination={false}
                  style={{
                    padding: 10,
                  }}
                />
              </Card>
            )}
          </div>
        </Col>
      </Row>
      {/* <div
        style={{
          display:"flex",
          width: "30px",
        }}
      >
      </div> */}
    </>
  );
};

export default TopSegment;
